import React from 'react';
import Slider from 'react-slick';
import cx from 'classnames';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import leasingFeedbacks from 'shared/data/json/leasingFeedbacks.json';

import chepuraImg from 'shared/assets/images/feedback/chepura.png';
import otrishkoImg from 'shared/assets/images/feedback/otrishko.png';
import efremovaImg from 'shared/assets/images/feedback/efremova.png';
import savchenkoImg from 'shared/assets/images/feedback/savchenko.png';
import shiloImg from 'shared/assets/images/feedback/shilo.png';
import mihalchenkoImg from 'shared/assets/images/feedback/mihalchenko.png';

import LeasingFeedbackCard from './LeasingFeedbackCard/LeasingFeedbackCard';

import s from './LeasingFeedback.css';

const isMobile = __APP__ === 'mobile';
const cardsCount = isMobile ? 1 : 3;

const Arrow = ({ className, myClassName, onClick }) =>
  <div className={cx(className, myClassName)} onClick={onClick} />;
Arrow.propTypes = {
  className: PropTypes.string.isRequired,
  myClassName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

const settingsSlider = {
  dots: true,
  infinite: false,
  speed: 2500,
  slidesToShow: cardsCount,
  slidesToScroll: cardsCount,
  arrows: false,
};

class LeasingFeedbacks extends React.Component {
  static propTypes = {};
  static defaultProps = {};
  render() {
    const avLinks = {
      chepura: chepuraImg,
      otrishko: otrishkoImg,
      efremova: efremovaImg,
      savchenko: savchenkoImg,
      shilo: shiloImg,
      mihalchenko: mihalchenkoImg,
    }
    return (
      <div className={`${s.root} ant-carousel`}>
        <Slider {...settingsSlider}>
          {leasingFeedbacks.map(item =>
            <LeasingFeedbackCard
              key={item.name}
              avatar={avLinks[item.avatar] || ''}
              name={item.name}
              text={item.text}
              rate={item.rate || 5}
            />,
          )}
        </Slider>
      </div>
    );
  }
}

export default withStyles(s)(LeasingFeedbacks);



// WEBPACK FOOTER //
// ./src/shared/components/Article/Leasing/LeasingFeedback/LeasingFeedback.js